import { type APIComponentAttributes } from '@ardoq/api-types';
import { componentOperations, modelOperations } from '@ardoq/core';
import { type WorkspaceAndModelLookup } from '@ardoq/data-model';
import { scopeDataOperations } from '@ardoq/scope-data';

/**
 * Whether the component's model lets it have children: always in a flexible
 * model, otherwise only when its type has child types. A component whose
 * workspace or model is not loaded cannot have children.
 */
export const canComponentHaveChildren = (
  component: APIComponentAttributes,
  workspaceAndModel: WorkspaceAndModelLookup
): boolean => {
  const found = scopeDataOperations.getWorkspaceAndModel(
    workspaceAndModel,
    component.rootWorkspace
  );
  if (!found) return false;
  const { componentTypesById } = modelOperations.getComponentTypes(found.model);
  return componentOperations.canComponentHaveChildren(
    component,
    componentTypesById,
    Boolean(found.model.flexible)
  );
};
